import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'


const routes = [
    {
        path: '/',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: LoginView
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        meta:{
            isShow:false,
        },
        children:[
            {
                path: '/showList',
                name: 'showList',
                meta:{
                    isShow:true,
                    title:'轮播图管理'
                },
                component: () => import(/* webpackChunkName: "showList" */ '../views/showList.vue')
            },
            {
                path: '/userList',
                name: 'userList',
                meta:{
                    isShow:true,
                    title:'校友信息管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/userList.vue')
            },
            {
                path: '/eventList',
                name: 'eventList',
                meta:{
                    isShow:true,
                    title:'校友活动管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/eventList.vue')
            },
            {
                path: '/messageList',
                name: 'messageList',
                meta:{
                    isShow:true,
                    title:'留言消息管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/messageList.vue')
            },
            {
                path: '/BranchOrganization',
                name: 'BranchOrganization',
                meta:{
                    isShow:true,
                    title:'校友分会管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/BranchOrganization.vue')
            },
            {
                path: '/SharingAdmView',
                name: 'SharingAdmView',
                meta:{
                    isShow:true,
                    title:'校友资源管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/SharingAdmView.vue')
            },
            {
                path: '/CompanyAdmView',
                name: 'CompanyAdmView',
                meta:{
                    isShow:true,
                    title:'校友企业管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/CompanyAdmView.vue')
            },
            {
                path: '/NewsAdmView',
                name: 'NewsAdmView',
                meta:{
                    isShow:true,
                    title:'新闻发布管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/NewsAdmView.vue')
            },
            {
                path: '/DonateAdmView',
                name: 'DonateAdmView',
                meta:{
                    isShow:true,
                    title:'校友捐赠管理'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/DonateAdmView.vue')
            },
            {
                path: '/UserApplyAdmView',
                name: 'UserApplyAdmView',
                meta:{
                    isShow:true,
                    title:'校友资源申请'
                },
                component: () => import(/* webpackChunkName: "login" */ '../views/UserApplyAdmView.vue')
            }
        ]
    },

]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),// 修改了 路由哈希模式
    routes
})

export default router
